// extracted by mini-css-extract-plugin
export default {"headerContent":"topHeader_headerContent__xnLXS","title":"topHeader_title__kx0TF","back":"topHeader_back__DtTu8"};